import React, { PureComponent, ReactNode } from "react";
import { Popin } from "src/components";
import styled from "styled-components";

import SingleFieldForm from "../../../../../components/Form/SingleFieldForm";
import { translate } from "../../../../../services/translation.service";
import theme from "../../../../../theme";
import { P } from "../../../../Semantic";

import validationSchema from "./validationSchema";

const Label = styled(P)`
  text-align: center;
`;

const EmailForm = styled(SingleFieldForm)`
  margin-top: ${theme.margins.marginBase};
`;

interface IProps {
  defaultEmail: string;
  loading: boolean;
  onClose: () => void;
  onConfirm: (email: string) => Promise<void>;
  open: boolean;
}

export default class PopupForm extends PureComponent<IProps> {
  public render(): ReactNode {
    const { defaultEmail, loading, onClose, open } = this.props;

    return (
      <Popin
        onClose={onClose}
        isOpen={open}
        title={translate("authentication.forgottenPassword")}
      >
        <Label>
          Veuillez renseigner votre adresse email.
          <br /> Nous vous enverrons un lien pour réinitialiser votre mot de
          passe.
        </Label>
        <EmailForm
          defaultValue={defaultEmail}
          fieldName="email"
          inputType="email"
          onButtonClick={this.props.onConfirm}
          validationSchema={validationSchema}
          loading={loading}
        />
      </Popin>
    );
  }
}
